import {
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    Chip,
    Box,
  } from "@mui/material";
  import { useState } from "react";
  
  export function CustomSingleSelect({
    label,
    labelId,
    optionItems,
    selectedValue,
    onChange,
    width
  }) {
    const [open, setOpen] = useState(false);
  
    return (
      <FormControl fullWidth size="small">
        <InputLabel id={labelId}>{label}</InputLabel>
        <Select
          label={labelId}
          value={selectedValue || ""}
          onChange={(e) => onChange([e.target.value])}
          open={open}
          onOpen={() => setOpen(true)}
          onClose={() => setOpen(false)}
          fullWidth
          size="small"
          sx={{
            height: 40,
            width: width || "100%",
            fontSize: "12px",
            cursor: "pointer",
          }}
          renderValue={(selected) => (
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Chip label={selected} size="small" />
            </Box>
          )}
        >
          {optionItems.map((item) => (
            <MenuItem key={item} value={item}>
              {item}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  }
  